module.exports = __webpack_public_path__ + "static/ebapp-2-50251b1adfe48ba8b2798e8e55ec4b68.jpg";